import { z } from "zod";
import {
  baseToolPatchPayloadSchema,
  baseToolPostPayloadSchema
} from "./base.js";
const CallTransferToolType = "call_transfer";
const callTransferToolSettingsSchema = z.object({
  /**
   * Destination (phone number or SIP URI)
   * e.g., "+15551234567", "sip:support@company.com", or "+15551234567,1234" (with extension)
   */
  destination: z.string().nonempty(),
  /** Optional SIP headers (provider-agnostic) */
  sip_headers: z.record(z.string(), z.string()).optional(),
  /** Transfer behavior timeout in seconds (default: 30) */
  timeout_seconds: z.number().positive().optional()
});
const callTransferToolPostPayloadSchema = baseToolPostPayloadSchema.extend({
  type: z.literal(CallTransferToolType),
  settings: callTransferToolSettingsSchema
});
const callTransferToolPatchPayloadSchema = baseToolPatchPayloadSchema.extend({
  type: z.literal(CallTransferToolType),
  settings: callTransferToolSettingsSchema.optional()
});
export {
  CallTransferToolType,
  callTransferToolPatchPayloadSchema,
  callTransferToolPostPayloadSchema,
  callTransferToolSettingsSchema
};
//# sourceMappingURL=callTransfer.js.map
